import React, { SVGProps } from 'react';

import { ReactComponent } from '../../assets/svg/lock.svg';


export default (props: SVGProps<any>) => <ReactComponent {...props} />;

